import { render, staticRenderFns } from "./WebcotacaoDialog.vue?vue&type=template&id=7fa1b2ba&scoped=true"
import script from "./WebcotacaoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WebcotacaoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WebcotacaoDialog.vue?vue&type=style&index=0&id=7fa1b2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1b2ba",
  null
  
)

export default component.exports